var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLockFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F75826",
  d: "M3.75 12.417q-.448 0-.766-.318a1.04 1.04 0 0 1-.318-.765V5.917q0-.447.318-.765t.765-.318h.542V3.75q0-1.124.792-1.916A2.6 2.6 0 0 1 7 1.042q1.125 0 1.916.792a2.6 2.6 0 0 1 .793 1.916v1.084h.541q.447 0 .765.318.32.318.319.765v5.417q0 .447-.319.765a1.04 1.04 0 0 1-.765.318zM7 9.709q.446 0 .764-.319.32-.318.319-.765 0-.447-.319-.765A1.04 1.04 0 0 0 7 7.542q-.447 0-.765.318a1.04 1.04 0 0 0-.318.765q0 .447.318.765.318.32.765.319M5.373 4.834h3.25V3.75q0-.677-.474-1.15A1.57 1.57 0 0 0 7 2.124q-.678 0-1.152.474T5.374 3.75z"
})));
export default SvgLockFilled;